import { useOffreService } from '@europrocurement/l2d-domain';
import { PackageJsonldPackageRead } from '@europrocurement/l2d-domain/openApi/ApiOffre';

export type PackageSearchItem = PackageJsonldPackageRead & Record<string, unknown>;

/**
 * Recherche de packages pour le filtre `selectApi` du listing des catalogues.
 * Calqué sur `useOffreFormalite` : recherche débouncée par nom commercial / libellé.
 */
const usePackageSearch = () => {
    const { packageApi } = useOffreService();
    let searchTimeout: ReturnType<typeof setTimeout> | undefined;

    const searchPackage = (search: string): Promise<Array<PackageSearchItem>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);

            searchTimeout = setTimeout(() => {
                packageApi
                    .apiPackagesGetCollection(
                        search && search !== '' ? { multiFieldSearch: search } : {},
                    )
                    .then((res) =>
                        resolve(
                            (res.data as { 'hydra:member'?: Array<PackageSearchItem> })[
                                'hydra:member'
                            ] ?? [],
                        ),
                    )
                    .catch((err) => reject(err));
            }, 600);
        });

    return { searchPackage };
};

export default usePackageSearch;
